import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { BASE_URL } from "../utils/reportsHelpers";

const useReportInsights = (currentUser) => {
  const [insights, setInsights] = useState([]);
  const [insightsLoading, setInsightsLoading] = useState(true);

  const fetchInsights = useCallback(async () => {
    if (!currentUser) return;
    setInsightsLoading(true);
    try {
      const res = await apiFetch(`${BASE_URL}/reports/insights?infinityCode=${currentUser}`, { method: "GET" });
      const data = await res.json();
      setInsights(data.insights || []);
    } catch {
      // non-critical section — fail quiet
    } finally {
      setInsightsLoading(false);
    }
  }, [currentUser]);

  useEffect(() => { fetchInsights(); }, [fetchInsights]);

  return { insights, insightsLoading, refetchInsights: fetchInsights };
};

export default useReportInsights;
